import { useEffect, useState } from 'react';
import useIsFirstRender from './useIsFirstRender';
import { useValueRef } from './useValueRef';

export const useDebouncedValue = (value, options) => {
  const [state, setState] = useState(value);

  const isFirstRender = useIsFirstRender();

  const optionsRef = useValueRef(options || {});

  useEffect(() => {
    if (!isFirstRender) {
      const { cb, delay = 500 } = optionsRef.current;

      const timeout = setTimeout(() => {
        setState(value);
        if (typeof cb === 'function') {
          cb(value);
        }
      }, delay);

      return () => clearTimeout(timeout);
    }
  }, [value, isFirstRender, optionsRef]);

  return state;
};
